module.exports = __webpack_public_path__ + "media/images/the-tags-f9b6cd87ff3f32b2353d971527b779e3.png";